import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'

type Value = {
  id: number | string
  image?: {
    url: string
    height: number
    width: number
    alternativeText: string
  }
  title: string
  description: string
  borderColor?: string | null
}
interface Props {
  class?: string
  title: string
  list: Value[]
  cta?: {
    title: string
    href: string
  }
  layout?: 'compact' | 'descriptive'
  theme?: 'dark' | 'light'
}

function ValueOutcomes({
  layout = 'descriptive',
  theme = 'dark',
  ...props
}: Props): JSX.Element {
  return (
    <section
      className={clsx(
        props.class,
        theme === 'dark' ? 'bg-blue-web-90 text-white' : 'text-black'
      )}
    >
      {layout === 'compact' ? (
        <ValueOutcomeCompact theme={theme} {...props} />
      ) : (
        <ValueOutcomesDesc {...props} />
      )}
    </section>
  )
}
export default ValueOutcomes

function ValueOutcomesDesc({ title, list, cta }: Props) {
  return (
    <div className="container font-heading | flex flex-col gap-8 lg:gap-16 | py-10 md:py-18">
      <h2
        className="text-3xl lg:text-5xl lg:text-center font-semibold | max-w-col-10 mx-auto"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6">
        {list.map(value => {
          return (
            <div key={value.id}>
              {value.image ? (
                <Image
                  src={value.image.url}
                  height={value.image.height}
                  width={value.image.width}
                  alt={value.image.alternativeText}
                  className="mb-4"
                />
              ) : null}

              <h3
                className="font-semibold text-xl lg:text-2xl | mb-4"
                dangerouslySetInnerHTML={{ __html: value.title }}
              />
              <span
                className="font-body text-base"
                dangerouslySetInnerHTML={{ __html: value.description }}
              />
            </div>
          )
        })}
      </div>

      {cta ? (
        <Link
          className="new-btn-secondary | font-medium text-lg lg:self-center | w-fit | py-2 px-4 "
          href={cta.href}
        >
          {cta.title}
        </Link>
      ) : null}
    </div>
  )
}

function ValueOutcomeCompact({ title, list, theme }: Props): JSX.Element {
  return (
    <div className="container font-heading | flex flex-col lg:items-center gap-8 lg:gap-12 | py-10 md:py-18">
      <h2 className="text-3xl lg:text-4xl font-medium">{title}</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-8 ">
        {list.map(value => {
          return (
            <div
              key={value.id}
              style={{ borderColor: `${value.borderColor}` }}
              className={clsx(
                theme === 'dark' ? 'text-white' : 'text-gray-70',
                'border-l-4 | px-8 lg:px-12'
              )}
            >
              <h3
                className="font-semibold text-2xl"
                dangerouslySetInnerHTML={{ __html: value.title }}
              />

              <div
                className="text-2xl"
                dangerouslySetInnerHTML={{ __html: value.description }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
